import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './AdminPage.css';

const AdminPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="admin-page">
      <header className="admin-header">
        <h2>Admin Panel</h2>
        <div className="admin-info">
          <span>Admin: {user?.email}</span>
        </div>
      </header>

      <main className="admin-content">
        <div className="admin-grid">
          <div className="admin-card">
            <h3>User Management</h3>
            <p>Manage user accounts and permissions</p>
            <div className="admin-stats">
              <span>Total Users: 1,234</span>
              <span>Active: 1,180</span>
            </div>
            <button className="admin-action">Manage Users</button>
          </div>

          <div className="admin-card">
            <h3>System Settings</h3>
            <p>Configure application settings and preferences</p>
            <div className="admin-stats">
              <span>Last Updated: 2 hours ago</span>
            </div>
            <button className="admin-action">View Settings</button>
          </div>

          <div className="admin-card">
            <h3>Analytics & Reports</h3>
            <p>View system analytics and generate reports</p>
            <div className="admin-stats">
              <span>Reports Generated: 45</span>
              <span>This Month: 12</span>
            </div>
            <button className="admin-action">View Reports</button>
          </div>

          <div className="admin-card">
            <h3>Security Logs</h3>
            <p>Monitor security events and access logs</p>
            <div className="admin-stats">
              <span>Recent Events: 23</span>
              <span>Alerts: 2</span>
            </div>
            <button className="admin-action">View Logs</button>
          </div>
        </div>

        <div className="admin-notice">
          <h4>Admin Access Notice</h4>
          <p>
            You are accessing the admin panel with elevated privileges. All
            actions are logged and monitored for security purposes.
          </p>
        </div>
      </main>
    </div>
  );
};

export default AdminPage;
